<template>
	<main class="intro-page">
		<div class="intro-banner">
			<img
				src="https://oss.cuttlefish.vip/file/h5upload/178884582198546658625.jpeg"
				alt="墨鱼旅行平台介绍"
			/>
		</div>

		<article class="intro-content">
			<header class="article-header">
				<span>MOYU TRAVEL</span>
				<h1>平台介绍</h1>
			</header>

			<section>
				<p>
					<strong>墨鱼旅行（英文名：MoYu Travel）</strong
					>是一个有趣的社交旅行平台，隶属于上海善臻文化传媒有限公司。平台秉承<strong>“和谁去，比去哪里更重要”</strong>的价值主张，以<strong>“让同频的人陪你看世界”</strong>为使命，致力于成为全球最大的旅行社交平台。
				</p>
				<p>
					墨鱼旅行开创了<strong>“社交旅行4.0”</strong>的全新商业模式，通过<strong>“兴趣社交+旅行服务”</strong>的深度融合，打破了传统OTA（在线旅游平台）以“产品”为中心的交易逻辑，转向以“人”为中心的社交价值创造。平台构建了去中心化的旅行社交生态，帮助用户实现从“找搭子”到“深度连接”的全链路体验，推动旅行行业从标准化产品交易向个性化情感连接的商业升级。
				</p>
			</section>

			<section>
				<h2>研发背景</h2>
				<p>
					墨鱼旅行的诞生源于创始人马丽萍（Sara）对传统旅游行业“社交缺失”痛点的深刻洞察。作为一名足迹遍布全球80多个国家和地区的深度旅行爱好者，马丽萍在多年的旅途中发现，尽管传统OTA（在线旅游平台）解决了“去哪儿”和“怎么去”的问题，但<strong>“和谁去”</strong>这一核心社交需求始终未被满足。尤其是在90后、00后成为旅行主力军的背景下，年轻人既厌倦了传统跟团游的刻板与束缚，又面临着独自旅行时的孤独感，他们渴望在旅途中结识志同道合的伙伴，体验更具创意和深度的玩法。
				</p>
				<p>
					基于此，墨鱼旅行于<strong>2018年正式立项</strong>，旨在打造一个“社交+旅行”的4.0时代在线社交旅行平台。其研发逻辑并非简单复制传统旅游产品的销售模式，而是利用大数据与AI算法，通过出发地、目的地、年龄层、兴趣标签等多维度进行精准匹配，帮助用户找到最契合的“旅行搭子”，从而解决“行前社交、行中拼团、行后分享”的全流程社交闭环。
				</p>
				<p>
					同时通过构建<strong>“墨鱼队长”机制</strong>，将具备专业技能、本地生活背景或独特旅行经验的达人，转化为平台的核心供给方，由他们发起原创、小众的深度旅行路线。
				</p>
				<p>
					在技术实现层面，墨鱼旅行注重构建去中心化的社交生态，通过严格的实名认证、社会身份认证及资金托管机制，确保用户在享受社交乐趣的同时，拥有安全、可靠的出行保障。这一研发背景奠定了墨鱼旅行在社交旅行细分赛道的独特地位，使其成为连接全球旅行爱好者的桥梁。
				</p>
			</section>

			<section>
				<div class="history-gallery">
					<img
						src="https://oss.cuttlefish.vip/file/h5upload/17893649050002361611.png"
						alt="发展历程图片1"
						draggable="false"
					/>
					<img
						src="https://oss.cuttlefish.vip/file/h5upload/178936490600030487053.png"
						alt="发展历程图片2"
						draggable="false"
					/>
					<img
						src="https://oss.cuttlefish.vip/file/h5upload/178936490700048123194.png"
						alt="发展历程图片3"
						draggable="false"
					/>
					<img
						src="https://oss.cuttlefish.vip/file/h5upload/178936490800086963439.png"
						alt="发展历程图片4"
						draggable="false"
					/>
					<img
						src="https://oss.cuttlefish.vip/file/h5upload/178936490900035307178.png"
						alt="发展历程图片5"
						draggable="false"
					/>
				</div>
				<h2>发展历程</h2>
				<div class="timeline">
					<div class="timeline-item">
						<strong>2018年6月</strong>
						<p>公司成立。上海善臻文化传媒有限公司（墨鱼旅行）成立，标志着“和谁去，比去哪儿更重要”的社交旅行模式开始探索。</p>
					</div>
					<div class="timeline-item">
						<strong>2019年</strong>
						<p>产品上线与模式验证。墨鱼旅行APP正式上线，明确了“社交旅游与创意路线”的发展方向。通过种子用户积累，初步验证了“墨鱼队长”模式的可行性，为后续规模化发展奠定了基础。</p>
					</div>
					<div class="timeline-item">
						<strong>2021年</strong>
						<p>资本认可与规模初显。墨鱼旅行完成初始融资，同年，创始人马丽萍入选《2021胡润U30中国创业领袖》榜单，品牌在旅游社交领域的影响力逐步提升。</p>
					</div>
					<div class="timeline-item">
						<strong>2022年</strong>
						<p>逆势盈利与数据增长。在旅游行业普遍受挫的背景下，墨鱼旅行实现逆势盈利，年营收达1.5亿元，证明了社交旅行商业模式的韧性与市场价值。</p>
					</div>
					<div class="timeline-item">
						<strong>2023年</strong>
						<p>融资突破与生态完善。墨鱼旅行连续完成A轮和A+轮累计4亿元融资，并实现稳定盈利。同时，获得出境游资质，完善了供应链体系。</p>
					</div>
					<div class="timeline-item">
						<strong>2024年</strong>
						<p>全球战略与内容升级。提出“发展1万名全球队长”计划，深化“墨鱼队长”生态建设。成立旅游垂类MCN机构，通过“内容+社交+交易”的业务模式，进一步巩固在社交旅行领域的影响力。</p>
					</div>
					<div class="timeline-item">
						<strong>2025年</strong>
						<p>持续迭代与生态闭环。平台通过持续的算法优化与社交功能迭代，致力于为用户提供更精准、安全的社交旅行体验。</p>
					</div>
					<div class="timeline-item">
						<strong>2026年</strong>
						<p>高速发展与线下布局。墨鱼旅行开启线上线下融合战略，相继落地多家线下社交旅行门店，验证了“线上社交+线下体验”的商业闭环。同年，公司正式启动“万店计划”，面向全国招募城市合伙人，推动社交旅行模式向更多城市复制。此外，旗下海外品牌MeetPanda也开始全球化布局加速推进。</p>
					</div>
				</div>
			</section>

			<section>
				<h2>核心功能与特色</h2>
				<p>
					墨鱼旅行的核心在于解决旅行中<strong>“和谁去”</strong>的社交痛点。通过独特的智能社交匹配算法进行“找搭子”，致力于为用户提供结伴旅行、主题路线规划及全球特产积分兑换等一站式服务。
				</p>

				<div class="feature-list">
					<div class="feature-item">
						<h3>一、智能社交匹配系统</h3>
						<p>平台基于大数据与AI算法，构建了多维度的旅行搭子匹配机制。用户可根据出发地、目的地、年龄层、兴趣标签（如自驾、潜水、摄影、美食）等维度进行筛选，系统通过算法实时推荐匹配度高的旅行伙伴。平台支持用户发布自由行邀约或拼团出游，旨在降低社交门槛，让旅行不再孤单。</p>
					</div>
					<div class="feature-item">
						<h3>二、墨鱼队长模式</h3>
						<p>墨鱼旅行开创了独特的“墨鱼队长”机制。队长通常由具备资深旅行经验、专业技能或本地生活背景的达人担任，分为专业队长与特邀队长。队长负责发起原创、小众的深度旅行路线，提供像朋友一样的陪伴式服务。平台对队长资质进行严格审核，确保服务的专业性与安全性。</p>
					</div>
					<div class="feature-item">
						<h3>三、一站式旅行服务</h3>
						<p>整合机票、酒店、门票、签证、租车等预订功能，并提供智能行程规划引擎。用户输入目的地后，系统可快速生成包含交通、住宿、景点的个性化方案，并支持手动调整优化。平台提供超2万条特惠主题路线，涵盖自由行、拼团游及定制游，满足用户多样化的出行需求。</p>
					</div>
					<div class="feature-item">
						<h3>四、安全保障机制</h3>
						<p>平台建立了严格的实名认证机制、社会身份认证及资金托管机制。用户付款后款项暂存第三方平台，行程结束确认收货后才会发放给队长，有效保障资金安全。同时，平台内置SOS紧急联络按钮及行程共享功能，确保用户的人身安全。</p>
					</div>
					<div class="feature-item">
						<h3>五、实时互动社区</h3>
						<p>内置“墨鱼星球”社交平台，支持图文/视频动态发布、旅行直播及同城群组互动。用户可分享旅行周记、攻略，大量的UGC内容增强了平台的社区粘性与用户活跃度。</p>
					</div>
					<div class="feature-item">
						<h3>六、线下社交空间</h3>
						<p>2026年，墨鱼旅行推出线下门店模型，以3×5平方米标准化空间为载体，配备“搭子墙”“社交角”等互动设施，为用户提供从线上到线下的沉浸式社交体验。门店模块化快装可实现1天落地，单人即可运营。</p>
					</div>
				</div>
			</section>

			<section>
				<h2>运营模式</h2>
				<p>
					墨鱼旅行以<strong>“同频匹配”</strong>为核心，通过“兴趣圈层+AI算法”精准连接用户，构建了从线上社交到线下组队的全链路闭环。其运营逻辑围绕“找对的人，去对的地方”展开。通过多维度标签与智能算法，实现搭子的精准筛选与匹配，确保用户在出发前即可锁定志同道合的队友。同时通过精细化社群运营，构建高粘性的社交旅行生态，将陌生人社交转化为熟人社交。
				</p>
				<p>
					2026年起，墨鱼旅行进一步拓展线上线下融合模式，通过线下门店承接线上流量，为用户提供真实的社交场景，同时为城市合伙人提供可复制的单店模型，实现品牌与合伙人的共赢发展。
				</p>
			</section>
		</article>
	</main>
</template>

<script>
	export default {
		name: "PlatformIntro",
	};
</script>

<style scoped lang="scss">
	.intro-page {
		box-sizing: border-box;
		padding: 48px 24px 80px;
		background: #f6f9fc;
		color: #3a4148;
	}

	.intro-banner,
	.intro-content {
		margin: 0 auto;
		max-width: 1200px;
	}

	.intro-banner {
		overflow: hidden;
		border-radius: 20px;
		background: #fff;
		box-shadow: 0 16px 44px rgba(29, 91, 132, 0.12);

		img {
			display: block;
			width: 100%;
			height: auto;
		}
	}

	.intro-content {
		box-sizing: border-box;
		margin-top: 36px;
		padding: 56px 70px;
		border-radius: 20px;
		background: #fff;
		box-shadow: 0 16px 44px rgba(29, 91, 132, 0.08);

		.article-header {
			margin-bottom: 38px;
			text-align: center;

			span {
				font-size: 13px;
				font-weight: 700;
				color: #26a1ff;
				letter-spacing: 4px;
			}

			h1 {
				margin: 10px 0 0;
				font-size: 38px;
				color: #202a33;
			}
		}

		section {
			margin-top: 52px;

			&:first-of-type {
				margin-top: 0;
			}
		}

		h2 {
			position: relative;
			margin: 0 0 24px;
			padding-left: 18px;
			font-size: 26px;
			color: #202a33;

			&::before {
				position: absolute;
				top: 3px;
				left: 0;
				width: 5px;
				height: 29px;
				border-radius: 3px;
				background: #26a1ff;
				content: "";
			}
		}

		p {
			margin: 0 0 18px;
			font-size: 16px;
			line-height: 2;
			text-align: justify;

			&:last-child {
				margin-bottom: 0;
			}
		}

		strong {
			font-weight: 700;
			color: #202a33;
		}
	}

	.history-gallery {
		display: flex;
		align-items: flex-start;
		gap: 10px;
		margin: 0 0 36px;

		img {
			display: block;
			flex: 1 1 0;
			width: 0;
			height: auto;
			border-radius: 12px;
			pointer-events: none;
			user-select: none;
			-webkit-user-drag: none;
		}
	}

	.timeline {
		position: relative;
		padding-left: 32px;

		&::before {
			position: absolute;
			top: 8px;
			bottom: 8px;
			left: 6px;
			width: 2px;
			background: #dceefa;
			content: "";
		}

		.timeline-item {
			position: relative;
			display: grid;
			grid-template-columns: 110px 1fr;
			margin-bottom: 22px;

			&::before {
				position: absolute;
				top: 8px;
				left: -31px;
				width: 12px;
				height: 12px;
				border: 3px solid #fff;
				border-radius: 50%;
				background: #26a1ff;
				box-shadow: 0 0 0 2px #9dd7ff;
				content: "";
			}

			> strong {
				color: #26a1ff;
			}

			p {
				margin: 0;
			}
		}
	}

	.feature-list {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 20px;
		margin-top: 28px;

		.feature-item {
			padding: 24px;
			border: 1px solid #e8f0f5;
			border-radius: 14px;
			background: #fbfdff;

			h3 {
				margin: 0 0 12px;
				font-size: 18px;
				color: #202a33;
			}

			p {
				margin: 0;
				font-size: 15px;
				line-height: 1.9;
			}
		}
	}

	@media screen and (max-width: 768px) {
		.intro-page {
			padding: 20px 14px 48px;
		}

		.intro-banner {
			border-radius: 12px;
		}

		.intro-content {
			margin-top: 18px;
			padding: 34px 20px;
			border-radius: 14px;

			.article-header {
				margin-bottom: 30px;

				h1 {
					font-size: 30px;
				}
			}

			section {
				margin-top: 40px;
			}

			h2 {
				font-size: 23px;
			}

			p {
				font-size: 15px;
				line-height: 1.9;
			}
		}

		.history-gallery {
			gap: 6px;
			margin-bottom: 24px;

			img {
				border-radius: 8px;
			}
		}

		.timeline {
			padding-left: 26px;

			.timeline-item {
				display: block;

				> strong {
					display: block;
					margin-bottom: 6px;
				}
			}
		}

		.feature-list {
			grid-template-columns: 1fr;
		}
	}
</style>
